import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 16" {...props}><path d="M2.3 8L10 1.1 9 0 0 8l9 8 1-1.1L2.3 8z" /></svg>);